<template>
    <div>
        <div class="columns">
            <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-mobile">
                <p id="back-to-results" class="is-size-7">
                    <a href="javascript:void(0);" @click="redirectToBusinessList" class="color-2aabe1"><i class="fas fa-arrow-left"></i> BACK TO BUSINESS LISTING</a>
                </p>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12-mobile is-12-desktop is-12-widescreen">
                <div class="level">
                    <div class="level-left">
                        <div class="title is-marginless is-paddingless">
                            <a v-if="!is_loading && !fetching_data" :href="business_url" target="_blank" class="has-text-underlined color-2aabe1">{{business_name}}</a>
                            <span v-if="!is_loading && !fetching_data" class="is-size-7 is-italic has-text-weight-normal">{{review_remaining_copy}}</span>
                            <span v-if="is_loading || fetching_data"
                                  class="button is-white has-text-right preloader"
                                  :class="{'is-loading': (is_loading || fetching_data)}"></span>

                        </div>
                    </div>
                    <button v-if="showDeleteButton" class="button is-pulled-right delete-biz-btn" @click="confirmDeleteBusiness()">DELETE</button>
                </div>
            </div>
        </div>
        <div class="columns" v-if="!is_loading && !fetching_data">
           <div class="column is-12 is-paddingless">
               <div class="tabs is-boxed">
                   <ul>
                       <li :class="{'is-active': isActiveTab('reviews')}">
                           <router-link :to="'/business/' + getBusinessSlug + '/reviews'">
                               <span>Reviews</span>
                           </router-link>
                       </li>
                       <li :class="{'is-active': isActiveTab('users')}">
                           <router-link :to="'/business/' + getBusinessSlug + '/users'">
                               <span>Users</span>
                           </router-link>
                       </li>
                       <li :class="{'is-active': isActiveTab('details')}">
                           <router-link :to="'/business/' + getBusinessSlug + '/details'">
                               <span>Profile</span>
                           </router-link>
                       </li>
                       <li :class="{'is-active': isActiveTab('billing')}">
                           <router-link :to="'/business/' + getBusinessSlug + '/billing'">
                               <span>Billing</span>
                           </router-link>
                       </li>
                       <li :class="{'is-active': isActiveTab('invoices')}">
                           <router-link :to="'/business/' + getBusinessSlug + '/invoices'">
                               <span>Invoices</span>
                           </router-link>
                       </li>
                       <li :class="{'is-active': isActiveTab('aliases')}">
                           <router-link :to="'/business/' + getBusinessSlug + '/aliases'">
                               <span>Aliases</span>
                           </router-link>
                       </li>
                     <li :class="{'is-active':isActiveTab('notes')}">
                           <router-link :to="'/business/'+getBusinessSlug + '/notes'">
                             <span>Notes</span>
                           </router-link>
                     </li>
                   </ul>
               </div>
           </div>
        </div>
        <router-view name="reviews" :subscription="subscription" :reviewsRemaining="total_reviews_remaining" v-if="!is_loading && !fetching_data"></router-view>
        <keep-alive>
            <router-view :businessName="business_name" name="users" v-if="!is_loading && !fetching_data"></router-view>
        </keep-alive>
        <keep-alive>
            <router-view :businessName="business_name" name="details" v-if="!is_loading && !fetching_data"></router-view>
        </keep-alive>
        <keep-alive>
            <router-view :businessName="business_name" name="billing" v-if="!is_loading && !fetching_data"></router-view>
        </keep-alive>
        <keep-alive>
            <router-view :businessName="business_name" name="invoices" v-if="!is_loading && !fetching_data"></router-view>
        </keep-alive>
        <keep-alive>
            <router-view :businessName="business_name" name="aliases" v-if="!is_loading && !fetching_data"></router-view>
        </keep-alive>
      <keep-alive>
        <router-view :businessName="business_name" name="notes" v-if="!is_loading && !fetching_data"></router-view>
      </keep-alive>

    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape,valid-jsdoc */
  import axios from 'axios'
  import qs from 'qs'
  import misc from '../mixins/misc.js'

  export default {
    mixins: [misc],
    data () {
      return {
        is_loading: true,
        fetching_data: false,
        business_name: '',
        business_url: '',
        totalReviews: 0,
        subscription: null,
        review_remaining_copy: '',
        total_reviews_remaining: 0,
        replies_remaining: 0,
        activeBizUsers: 0
      }
    },
    created () {
       this.getBusinessRemainingReviews()
        window.events.$on('businessNameUpdated', this.updateBusinessName)
    },
    mounted () {
        window.events.$on('task.deleteBusiness', this.deleteBusiness)
    },
    computed: {
      getBusinessSlug () {
        return this.$router.currentRoute.params.slug
      },
      showDeleteButton () {
          return !this.is_loading && this.totalReviews === 0 && (!this.subscription || this.subscription === 'Free') && this.activeBizUsers === 0
      }
    },
    methods: {
      /*
       * This will redirect to biz list page
       */
      redirectToBusinessList () {
          if (localStorage.getItem('bizFilterList')) {
              let query = JSON.parse(localStorage.getItem('bizFilterList'))
              let filters = qs.stringify(query)
              localStorage.removeItem('bizFilterList')
              this.$router.push(`/businesses?${filters}`)
          } else {
              this.$router.push(`/businesses`)
          }
      },
      isActiveTab (tab) {
        return this.openActiveTabForURL(this.$router.currentRoute.name, tab)
      },
      reviewRemainingCopy (data) {
        this.total_reviews_remaining = data.total_reviews_remaining
        if (data.subscription === 'Free' && parseInt(data.total_reviews_remaining) === 0) {
          this.review_remaining_copy = ''
        } else if (data.subscription === 'Enterprise') {
          this.review_remaining_copy = 'unlimited reviews remaining'
        } else {
          this.review_remaining_copy = `${data.total_reviews_remaining} reviews remaining | ${data.review_replies_remaining} replies remaining`
        }

         if (data.subscription === 'Free') {
            if (this.review_remaining_copy) {
                this.review_remaining_copy += ' - '
            }
            this.review_remaining_copy += `${data.review_replies_remaining} replies remaining`
          }
      },
      /**
       * Make request to api to get business's remaining reviews
       * @returns {number | null}
       */
      getBusinessRemainingReviews () {
        this.fetching_data = true
        axios.get(`/${this.getBusinessSlug}/remaining-reviews`)
            .then((response) => {
              this.business_name = response.data.business_name
              this.business_url = process.env.HP_APP_URL + `/${this.getBusinessSlug}`
              this.subscription = response.data.subscription
              this.totalReviews = response.data.total_reviews
              this.activeBizUsers = response.data.active_biz_users
              this.reviewRemainingCopy(response.data)
              this.is_loading = false
              this.fetching_data = false
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Update business name on UI
       * @returns {void}
       */
      updateBusinessName () {
        this.business_name = localStorage.getItem('business_name')
      },
      confirmDeleteBusiness () {
          // show detele modal
          let options = {
              'title': 'Delete a Business ?',
              'btn_action_title': 'DELETE BUSINESS',
              'show_btns': true,
              deleteBusiness: true,
              task: 'task.deleteBusiness',
              businessSlug: this.getBusinessSlug
          }
          modal(options)
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    tr.goto-business {
        cursor: pointer;
    }

    .tabs li.is-active a {
        color: #2aabe1 !important;
    }
    .tabs ul  {
        margin-left: 13px;
    }
    .level-left {
      max-width: 80%
    }
</style>



// WEBPACK FOOTER //
// src/layouts/BusinessLayout.vue